/**
 * @generated SignedSource<<7e1b3304b1317532cc6688812a22304d>>
 * @relayHash 591ee1e6903003502f2d9699f7264b08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0598748977910010985d9124ceae3cedbfcafad172500bf6a05983a6ed2a6cf0

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { IssueAppSelectorOrchestratorQuery } from './IssueAppSelectorOrchestratorQuery.graphql';

const node: PreloadableConcreteRequest<IssueAppSelectorOrchestratorQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0598748977910010985d9124ceae3cedbfcafad172500bf6a05983a6ed2a6cf0",
    "metadata": {},
    "name": "IssueAppSelectorOrchestratorQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
